module.exports = __webpack_public_path__ + "img/00019.80e07622.webp";